var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCube(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3473",
    "data-name": "Rectangle 3473",
    width: 16,
    height: 16,
    transform: "translate(8 7.983)",
    fill: "#333"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Mask_Group_231",
    "data-name": "Mask Group 231",
    transform: "translate(-8 -7.983)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "cube",
    transform: "translate(6.858 6.84)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2716",
    "data-name": "Path 2716",
    d: "M15.745,4.867a.143.143,0,0,0,0-.247L10.29,1.452a2.291,2.291,0,0,0-2.3,0L2.54,4.621a.143.143,0,0,0,0,.247L9.07,8.709a.143.143,0,0,0,.145,0Z",
    fill: "#333",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2717",
    "data-name": "Path 2717",
    d: "M1.928,5.839a.143.143,0,0,0-.214.124v6.21a1.714,1.714,0,0,0,.851,1.478l5.791,3.472A.143.143,0,0,0,8.57,17V9.8A.143.143,0,0,0,8.5,9.672Z",
    fill: "#333"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2718",
    "data-name": "Path 2718",
    d: "M9.713,9.82V17a.143.143,0,0,0,.214.123l5.79-3.472a1.714,1.714,0,0,0,.852-1.476V5.963a.143.143,0,0,0-.214-.123L9.784,9.7a.143.143,0,0,0-.072.123Z",
    fill: "#333"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCube);
export default __webpack_public_path__ + "static/media/cube.7d2fc71e351b0737ad191fec86bd1f3d.svg";
export { ForwardRef as ReactComponent };